export default [
  {
    id: 'slack',
    icon: 'slack',
    name: 'Slack',
    bundleID: 'com.tinyspeck.slackmacgap',
    processName: 'Slack',
  },
  {
    id: 'teams',
    icon: 'teams',
    name: 'Teams',
    bundleID: 'com.microsoft.teams2',
    // msteams triggers meeting notification twice as it has 2 separate processes using mic/cam
    // we have child bundle id to not generate notification for helpers mic/cam usage
    childBundleID: 'com.microsoft.teams2',
    processName: 'Microsoft Teams',
  },
  {
    id: 'zoom',
    icon: 'zoom',
    name: 'Zoom',
    bundleID: 'us.zoom.xos',
    processName: 'zoom.us',
  },
  {
    id: 'webex',
    icon: 'webex',
    name: 'Webex',
    bundleID: 'Cisco-Systems.Spark',
    processName: 'Webex',
  },
  {
    id: 'facetime',
    icon: 'facetime',
    name: 'Facetime',
    bundleID: 'com.apple.avconferenced',
    processName: 'avconferenced',
  },
  {
    id: 'whatsapp',
    icon: 'whatsapp',
    name: 'WhatsApp',
    bundleID: 'net.whatsapp.WhatsApp',
    processName: 'WhatsApp',
  },
  {
    id: 'safari',
    icon: 'safari',
    name: 'Safari',
    bundleID: 'com.apple.Safari',
    processName: 'Safari',
  },
  {
    id: 'chrome',
    icon: 'chrome',
    name: 'Chrome',
    bundleID: 'com.google.Chrome',
    processName: 'Google Chrome',
  },
  {
    id: 'firefox',
    icon: 'firefox',
    name: 'Firefox',
    bundleID: 'org.mozilla.firefox',
    processName: 'Firefox',
  },
  {
    id: 'edge',
    icon: 'edge',
    name: 'Edge',
    bundleID: 'com.microsoft.edgemac',
    processName: 'Microsoft Edge',
  },
];
